<script setup>
import { computed, reactive, ref } from 'vue';
import { dateToLocaleDateString } from '../../libs/dates';

const props = defineProps({
  condicion: { type: Object, required: true },
});

const condicionInterna = reactive(props.condicion);

const fechaInicio = computed(() => (
  condicionInterna.config?.fecha_inicio
    ? dateToLocaleDateString(condicionInterna.config.fecha_inicio)
    : null
));
const fechaFin = computed(() => (
  condicionInterna.config?.fecha_fin
    ? dateToLocaleDateString(condicionInterna.config.fecha_fin)
    : null
));
</script>

<template>
  <div class="form-group-inline-flex">
    <div>
      {{ $t('fecha_nacimiento') }}:
      <span class="m-l">
        <strong>{{ fechaInicio }}</strong>
        -
        <strong>{{ fechaFin }}</strong>
      </span>
    </div>
  </div>
</template>
